var Temoignages_Slider = {
    init:function(){

        $(window).resize(function(){
            Temoignages_Slider.resize();
        });

        Temoignages_Slider.resize();


    },
    resize:function(){

        var _carousel = $(".temoignages-container .temoignages-list");

        if (_carousel.hasClass('slick-initialized')) {
            _carousel.slick('unslick');
        }

        var _slides_to_show = 1;
        var els = document.querySelectorAll(".temoignages-list");

        Array.prototype.forEach.call(els, function(el) {
            _slides_to_show = parseInt( window.getComputedStyle(el).getPropertyValue("--nbslide"));
        });
        console.log("SLide to show : " + _slides_to_show);

        _carousel.slick({
            arrows:true,
            dots:false,
            infinite: false,
            variableWidth:true,
            slidesToShow: _slides_to_show,
            focusOnSelect: false,
            touchThreshold:500,
            prevArrow:_carousel.parent().find(".arrow-container.left"),
            nextArrow:_carousel.parent().find(".arrow-container.right"),
        });
    }
}
$(window).on("load", function(){
    if($(".temoignages-list").length){
        Temoignages_Slider.init();
    }
})